import { useEffect, useState } from "react";
import { BREAKPOINTS } from "../constants";

export function useMediaQuery(): number[] {
  const [size, setSize] = useState([0, 0]);

  useEffect(() => {
    function updateSize(): void {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return (): void => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}

export function useIsSmDesktopWidth(): boolean {
  const width = useMediaQuery()[0];
  return width >= BREAKPOINTS["screen-sm-desktop-min"];
}

export function useIsLgDesktopWidth(): boolean {
  const width = useMediaQuery()[0];
  return width >= BREAKPOINTS["screen-lg-desktop-min"];
}

export function useIsMobileWidth(): boolean {
  const width = useMediaQuery()[0];
  return width <= BREAKPOINTS["screen-lg-mobile-max"];
}

export function useIsTouchScreenWidth(): {
  isMobileScreen: boolean;
  isTabletScreen: boolean;
} {
  const width = useMediaQuery()[0];
  return {
    isMobileScreen: width <= BREAKPOINTS["screen-lg-mobile-max"],
    isTabletScreen:
      width >= BREAKPOINTS["screen-tablet-min"] &&
      width <= BREAKPOINTS["screen-tablet-max"]
  };
}
